const module = { name: 'movie/shared/desktop/cast', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Splide as Splide } from 'require-core';



import { default as castModal } from 'swug-fdRequire-call:movie/shared/castModal';



const Selectors = {
    CAST_SLIDER: '#person-gallery-splide',
    CAST_CONTAINER: '#movie-details-person-container',
    CAST_NAV_BTNS: '.js-person-gallery-arrow-btn',
}


const Styles = {
    HIDE: 'hide',
}
function onNavBtnClick() {
    track({
        event: EventTypes.GENERIC_CLICK,
        genericClickDetails: 'arrow clicks',
    });
}
function attach() {
    if (!document.querySelectorAll(Selectors.CAST_SLIDER)?.length) {
        debugLog.info(module.name, 'no slider');
        const container = document.querySelectorAll(Selectors.CAST_CONTAINER);
        container.forEach(c => c.classList.add(Styles.HIDE));
        return container?.length && ([...container].every(item => item.innerText = ''));
    }
    castModal.attach({ root: document.querySelector(Selectors.CAST_SLIDER) });
    document.querySelectorAll(Selectors.CAST_NAV_BTNS)
        .forEach(item => item.addEventListener('click', onNavBtnClick));
    new Splide(Selectors.CAST_SLIDER, {
        fixedWidth: '95px',
        fixedHeight: '175px',
        slideFocus: false,
        pagination: false,
    }).mount();
}
module.exports = {
    attach
};
export default module.exports;